import { borderToken } from "./semantics.js";
const SIDES = ["top", "bottom", "left", "right"];
const band = (side, rect, width) => {
    const { x, y, width: w, height: h } = rect;
    if (side === "top")
        return { x, y, width: w, height: width };
    if (side === "bottom")
        return { x, y: y + h - width, width: w, height: width };
    if (side === "left")
        return { x, y, width, height: h };
    return { x: x + w - width, y, width, height: h };
};
const DASH = {
    dashed: (width) => [4 * width, 2 * width],
    dotted: (width) => [width, width],
};
/**
 * Paints the edges inside the cell rect, thinner first so a wide edge such as a selection
 * indicator lands on top. Dash patterns restart at the cell's own corner, so every cell paints
 * the same pixels however it is scrolled or partially repainted.
 */
export const paintCellBorders = (ctx, rect, borders, resolveColor) => {
    const edges = SIDES.flatMap((side) => {
        const edge = borders[side];
        return edge ? [{ side, edge, width: edge.width ?? 1 }] : [];
    }).sort((a, b) => a.width - b.width);
    if (edges.length === 0)
        return;
    ctx.save();
    for (const { side, edge, width } of edges) {
        const b = band(side, rect, width);
        const color = resolveColor(borderToken(edge.color ?? "default"));
        if (!edge.style || edge.style === "solid") {
            ctx.fillStyle = color;
            ctx.fillRect(b.x, b.y, b.width, b.height);
            continue;
        }
        ctx.strokeStyle = color;
        ctx.lineWidth = width;
        ctx.setLineDash(DASH[edge.style](width));
        ctx.lineDashOffset = 0;
        ctx.beginPath();
        if (side === "top" || side === "bottom") {
            ctx.moveTo(b.x, b.y + width / 2);
            ctx.lineTo(b.x + b.width, b.y + width / 2);
        }
        else {
            ctx.moveTo(b.x + width / 2, b.y);
            ctx.lineTo(b.x + width / 2, b.y + b.height);
        }
        ctx.stroke();
    }
    ctx.restore();
};
//# sourceMappingURL=cellBorders.js.map